import React from 'react';

const RouteErrorScreen = () => (
  <div className="notFound">There was an error loading the page.</div>
);

export default RouteErrorScreen;
